var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "list-group-item", class: _vm.context },
    [
      _c("strong", { staticClass: "session-status" }, [
        _vm._v(_vm._s(_vm.statusKey) + ":")
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "bounce", mode: "out-in" } }, [
        _c("span", { key: _vm.statusValue, staticClass: "session-status" }, [
          _vm._v("  " + _vm._s(_vm.statusValue) + "  ")
        ])
      ]),
      _vm._v(" "),
      _vm.exposureTime
        ? _c(
            "span",
            { staticClass: "badge badge-pill badge-info session-status" },
            [_vm._v(_vm._s(_vm.exposureTime) + " seconds left")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }